import React from 'react'

export default function Error() {
  return (
    <div>Something Went Wrong</div>
  )
}
